import React from 'react';
import './PageSkeleton.css';

const PageSkeleton = ({ variant = 'default' }) => {
  if (variant === 'form') {
    return (
      <div className="page-skeleton page-skeleton--form" role="status" aria-live="polite" aria-label="Loading page">
        <div className="page-skeleton__nav skeleton-block" />
        <div className="page-skeleton__logo skeleton-block skeleton-block--logo" />
        <div className="page-skeleton__line skeleton-block skeleton-block--title" />
        <div className="page-skeleton__line skeleton-block skeleton-block--subtitle" />
        <div className="page-skeleton__card skeleton-block">
          <div className="page-skeleton__line skeleton-block" />
          <div className="page-skeleton__line skeleton-block skeleton-block--input" />
          <div className="page-skeleton__line skeleton-block" />
          <div className="page-skeleton__line skeleton-block skeleton-block--input" />
          <div className="page-skeleton__line skeleton-block skeleton-block--button" />
        </div>
      </div>
    );
  }

  return (
    <div className="page-skeleton page-skeleton--default" role="status" aria-live="polite" aria-label="Loading page">
      <div className="page-skeleton__logo skeleton-block skeleton-block--logo" />
      <div className="page-skeleton__line skeleton-block skeleton-block--title" />
      <div className="page-skeleton__line skeleton-block" />
      <div className="page-skeleton__line skeleton-block" />
      <div className="page-skeleton__line skeleton-block skeleton-block--short" />
    </div>
  );
};

export default PageSkeleton;
